import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseService } from 'src/app/shared/services';
import { DownloadService } from 'src/app/shared/services/download.service';
import { UserService } from 'src/app/shared/services/user.service';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import {IWGSharedService} from '../../../shared/services/shared.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  fileHasScanError:boolean = false;
  scanErrorMessage:string = null;
  isRequired:boolean = false;
  allowedFileTypeExtensions:any;
  dialogRef:any = null;
  isFileUploading:boolean = false;
  isFileUploaded:boolean = false;
  fileUploadError:boolean = false;
  @Input("file-property") fileProperty;
  @Input("upload-url") uploadUrl;
  @Input ("required") required = false;
  @Input("uploaded-file-name") uploadedFileName;
  @Input ("flag") flag;
  @Input ("isBlur") isBlur:boolean = false;
  @Input ("isEvent") isEvent:boolean = false;
  @Output() uploadedfilename= new EventEmitter();
  invalidFiles=[];
  selectFileDisplayName = 'Upload a File';
  selectedFileDisplayName = 'Selected File';

  constructor(
    private userService: UserService, private dialog: MatDialog,
    private baseService: BaseService, private down: DownloadService, private sharedService: IWGSharedService
    ) {
    this.allowedFileTypeExtensions = userService.getAllowedFileTypeExtensions();
  }

  ngOnInit(): void {
    if (this.fileProperty == 'worker_profile_resume') {        
      this.selectFileDisplayName = 'Upload Resume/Portfolio';
      this.selectedFileDisplayName = 'Selected Resume/Portfolio';
    }
    this.sharedService.iwgfileattached.subscribe((data) => {
        if(!data){
            return
        }
       this.isFileUploaded = false;
       this.uploadedFileName = "";
    });
    this.sharedService.iwgfilefiledeleted.subscribe((data) => {
        if(!data){
            return
        }
          this.isFileUploaded = false;
          this.uploadedFileName = "";         
          this.selectFileDisplayName = 'Upload Resume/Portfolio';
    });
    this.sharedService.iwgfileattachedreset.subscribe(this.resetDoRefreshListener.bind(this));
  }
    resetDoRefreshListener = () => {
        this.fileHasScanError = false;
        this.scanErrorMessage = '';
    }
    DOResetDoRefreshListener() {
        this.resetDoRefreshListener();
    }
  
  onClick(): void{
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      const file = fileUpload.files;
      this.uploadFiles(file);
      fileUpload.value = ""; 
    };
    fileUpload.click();
  }

  uploadFiles(file){    
    if(!file){
      return;
    }
    var length = Array.from(file).length;    
    var messageshown =false;
    var formData = new FormData();  
    for (var index = 0; index < length; index++) {
        var isValidFile = true;       
        formData.append(this.fileProperty, file[index],file[index].name);        
        if (!this.userService.validateSelectedFileType(file[index].name, file[index].type)) {
          this.invalidFiles.push(file[index].name);
            isValidFile = false;
        }
        if (!isValidFile) { 
         
          if (this.invalidFiles.length > 0 && messageshown==false) { 
           
            messageshown=true;
            alert(this.userService.getFileUploadUnSupportErrorMessage(this.invalidFiles.join(','), true));
           }
            file.splice(index, 1);
        }
    }
    
   
    if (Array.from(file).length <= 0) { 
    return;
    }
    this.openDialog();
  this.sharedService.iwgfileuploadstatus.next( true); 
    this.isFileUploading = true;
    this.fileHasScanError = false;
    this.scanErrorMessage = null;
    let data = {};
    data[this.fileProperty] = file[0];    
    this.down.upload(this.uploadUrl,formData)
    .then(
      resp => {
          this.isFileUploading = false;
        this.closeDialog();       
        this.sharedService.iwgfileuploadstatus.next( false);
        if (resp.data.ErrorCode == 200) {
            this.isFileUploaded = true;
            this.fileUploadError = false;
            if(resp.config.data[this.fileProperty]){
                this.uploadedFileName = resp.config.data[this.fileProperty].name;
            }else{
                this.uploadedFileName = data[this.fileProperty].name;               
            }
            if(this.isEvent){
            this.uploadedfilename.emit( this.uploadedFileName);
            }
            if (this.fileProperty == 'worker_profile_resume') {
                this.sharedService.iwgfileuploaded.next(resp.data);
            } else {
                this.sharedService.iwgfileuploaded.next(true);
            }
        } else {
            if (resp.data.ErrorCode === 406 || resp.data.ErrorCode === 413 || resp.data.ErrorCode == 400)
            {
                this.fileHasScanError = true;
                this.scanErrorMessage = resp.data.Message.Details;
            }
            else {
                this.fileUploadError = true;
            }
            this.sharedService.iwgfileuploadstatus.next("Error uploading file");
            console.error('Error uploading file', resp);
        }
      }
    )
    .catch(
      err => {
        this.closeDialog();
        console.log(err);
        this.isFileUploading = false;
        this.fileUploadError = true;
      }
    );
  }
  openDialog(): void {
    if(this.isBlur) {
      this.sharedService.isBlurredBg.next(true);
    }
    this.dialogRef = this.dialog.open(AlertMessageComponent, {disableClose: true});
  }
  closeDialog(): void{
    if(this.isBlur) {
      this.sharedService.isBlurredBg.next(false);
    }
    this.dialogRef.close();
  }

}
